import { jsx as e, jsxs as i } from "react/jsx-runtime";
import { concatClassNames as r } from "@sys42/utils";
import { ButtonPrimary as u } from "../../ButtonPrimary/index.js";
import { Headline3Serif as l } from "../../Headline3Serif/index.js";
import '../../../assets/index27.css';
var a = "_newsletterSignUp_1ifld_1",
  o = "_subline_1ifld_4",
  m = "_inputWithButton_1ifld_11",
  t = {
    newsletterSignUp: a,
    subline: o,
    inputWithButton: m
  };
function h(n) {
  var s = n.className;
  return /* @__PURE__ */e("section", {
    className: r(s, t.newsletterSignUp),
    children: /* @__PURE__ */i("form", {
      action: "//userbrain.us1.list-manage.com/subscribe",
      method: "get",
      id: "mc-embedded-subscribe-form",
      name: "mc-embedded-subscribe-form",
      target: "_blank",
      noValidate: !0,
      children: [/* @__PURE__ */e(l, {
        customTag: "h1",
        children: "Newsletter"
      }), /* @__PURE__ */e("div", {
        className: t.subline,
        children: "Want simple user testing tips & tricks? Sign up to our newsletter."
      }), /* @__PURE__ */i("div", {
        className: t.inputWithButton,
        children: [/* @__PURE__ */e("input", {
          type: "email",
          name: "EMAIL",
          placeholder: "Enter your email",
          required: !0
        }), /* @__PURE__ */e("input", {
          type: "hidden",
          name: "u",
          value: "8e3738f67ef6b3aa854a85b00"
        }), /* @__PURE__ */e("input", {
          type: "hidden",
          name: "group[169][128]",
          value: "1"
        }), /* @__PURE__ */e("input", {
          type: "hidden",
          name: "id",
          value: "9dfb91d9c7"
        }), /* @__PURE__ */e(u, {
          type: "submit",
          children: "Sign up"
        })]
      })]
    })
  });
}
export { h as NewsletterSignUp };